import axios from "@/plugins/axios";

let url = "/api/v1/center/faqs";

export default {
    getFaqs(data){
        return axios.get(url, data).then(result => result.data);
    },
    getFaq(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postFaq(data){
        return axios.post(url, data).then(result => result.data);
    },
    putFaq(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteFaq(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
